import emitter from '../emitter'
import Litepicker from 'litepicker'
import { connectRange } from 'instantsearch.js/es/connectors'

const renderCalendar = (renderOptions, isFirstRender) => {
  if (!isFirstRender) return

  const { refine, widgetParams } = renderOptions

  const numberColsMonths = window.innerWidth < 1024 ? 1 : 2
  let tempDate1
  let tempDate2

  /* eslint-disable-next-line */
  const picker = new Litepicker({
    element: widgetParams.container,
    inlineMode: true,
    singleMode: false,
    numberOfMonths: numberColsMonths,
    numberOfColumns: numberColsMonths,
    minDate: widgetParams.minDate ? Date.now() : 0,
    selectForward: true, // see to change
    selectBackward: false,
    lang: 'fr',
    /* eslint-disable */
    setup: (picker) => {
      picker.on('preselect', (date1, date2) => {
        tempDate1 = date1
        tempDate2 = date2
      }),
      picker.on('selected', (date1, date2) => {
        let end = null
        const start = new Date(date1.dateInstance).getTime() / 1000

        if (date2) {
          end = new Date(date2.dateInstance).getTime() / 1000
        }

        if (date2) {
          refine([start, end])
        } else {
          refine([start])
        }
      }),
      picker.on('render:day', (day, date) => {
        day.innerHTML = `<span>${day.textContent}</span>`
      })
    },
    /* eslint-enable */
  })

  widgetParams.rangeDateSingle.addEventListener('click', (e) => {
    e.target.classList.toggle('is-active')

    picker.clearSelection()

    if (e.target.classList.contains('is-active')) {
      picker.setOptions({
        singleMode: true,
        selectForward: false,
        selectBackward: false,
      })

      if (tempDate1 !== undefined) {
        picker.setDate(tempDate1)
      }
    } else {
      picker.setOptions({
        singleMode: false,
        selectForward: true,
        selectBackward: false,
      })

      picker.setDateRange(tempDate1, tempDate2)
    }
  })

  emitter.on('clearCalendar', () => {
    picker.clearSelection()
    picker.gotoDate(Date.now())
  })
}

const customCalendar = connectRange(renderCalendar)

export default customCalendar
